import React from 'react';
import './input.scss';

export const Input = React.forwardRef(({
    className = '',
    type = 'text',
    ...props
}, ref) => {
    return (
        <input
            ref={ref}
            type={type}
            className={`input ${className}`}
            {...props}
        />
    );
});

Input.displayName = 'Input';
